// The payload is the deleted staff member's id, wrapped in an object: synapse's `DefaultPayload`
// requires `payload` to be a record (or an array of records), never a bare primitive.
export type StaffMemberDeletedPayload = {
	staffMemberId: number;
};

export type StaffMemberDeletedAction = {
	type: 'STAFF_MEMBER_DELETED';
	payload: StaffMemberDeletedPayload;
	organizationId: number;
};

export default (payload: StaffMemberDeletedPayload, organizationId: number): StaffMemberDeletedAction => ({
	type: 'STAFF_MEMBER_DELETED',
	payload,
	organizationId,
});
